import * as Yup from "yup";
import { useAddBoardPanelAssociation } from "../../../utils/hooks/commonly-stored/uploaded-board/updates/board";
import LoadingIcon from "../../common/LoadingIcon";
import { Title } from "./BoardInventoryStyles";
import { Formik } from "formik";
import { FormContainer } from "../parts/InventoryUpdates/InventoryUpdatesStyles";
import FormikSelect from "../../formik-form-components/FormikSelect";
import Button from "../../common/Button";
import { ButtonTypes } from "../../common/Button/constants";
import {
  InventoryItem,
  InventoryItemType,
} from "../../../utils/hooks/inventory/useInventoryItems";
import useAllInventoryItems from "../../../utils/hooks/inventory/useAllInventoryItems";

interface SelectPanelValues {
  panels: string[];
}

const selectPanelsSchema = Yup.object().shape({
  panels: Yup.array().of(Yup.string()),
});
export default function SelectPanel({
  boardId,
  closeModal,
}: {
  boardId: string;
  closeModal: () => void;
}) {
  const { items } = useAllInventoryItems(InventoryItemType.PANELS);
  const { addPanelToBoard } = useAddBoardPanelAssociation();
  const selectPanelForProject = (values: SelectPanelValues) => {
    addPanelToBoard(boardId, {
      panel_ids: values.panels,
    });
    closeModal();
  };
  const PanelLabel = ({ panelItem }: { panelItem: InventoryItem }) => {
    const nickName = panelItem.nickname ? ` - ${panelItem.nickname} ` : " ";
    return (
      <div>{`${panelItem.flashpcb_container_barcode}${nickName}(${panelItem.last_counted_amount})`}</div>
    );
  };

  if (items === null) {
    return <LoadingIcon text={"Loading panels..."} />;
  }
  return (
    <>
      <Title>Select panel to associate with project</Title>
      <Formik
        initialValues={{ panels: [] }}
        onSubmit={selectPanelForProject}
        validationSchema={selectPanelsSchema}
      >
        {({ handleSubmit, isValid }) => (
          <FormContainer onSubmit={handleSubmit}>
            <FormikSelect
              name={"panels"}
              label={"Panels in inventory"}
              isMulti={true}
              options={items?.inventory_items.map((panel) => ({
                label: <PanelLabel panelItem={panel} />,
                value: panel.id,
              }))}
            />
            <Button
              label={"Update panel association"}
              type={ButtonTypes.SUBMIT}
              centerText
              disabled={!isValid}
            />
          </FormContainer>
        )}
      </Formik>
    </>
  );
}
